import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { TaxAdvisors } from "../taxAdvisors/TaxAdvisors";

export const Route = createFileRoute("/steuerberater")({
  loader: async ({ context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(trpc.taxAdvisories.list.queryOptions());
  },
  component: TaxAdvisorsRoute,
});

function TaxAdvisorsRoute() {
  const isManageTaxAdvisorsEnabled = useIsFeatureEnabled("manageTaxAdvisors");

  if (!isManageTaxAdvisorsEnabled) {
    return <Navigate to="/" />;
  }

  return <TaxAdvisors />;
}
